﻿import { Plugin, WordCount } from 'ckeditor5';

function sleep(time) {
    return new Promise((resolve, reject) => {
        window.setTimeout(() => resolve(), time);
    });
}

export default class MaxLength extends Plugin {
    static get pluginName() { return "MaxLength" };

    // Make sure the "WordCount" plugin is loaded.
    get requires() {
        return [WordCount];
    }

    init() {
        const editor = this.editor,
            maxLength = editor.config.get('MaxLength.maxLength'),
            maxLengthVisibleAt = editor.config.get('MaxLength.visibleAt') || 0.8;

        if (maxLength) {
            const wordCountPlugin = editor.plugins.get('WordCount');

            const counterField = document.createElement('span');
            counterField.classList.add('length-indicator');

            function checkAbort(eventInfo, data) {
                if (checkLength(wordCountPlugin.characters, maxLength)) {
                    // Current length is too big, but delete should be possible (8->Backspace, 46->Delete)
                    // List of keystroke: https://www.freecodecamp.org/news/javascript-keycode-list-keypress-event-key-codes/#a-full-list-of-key-event-values
                    let isAllowed = data.ctrlKey === true ||
                        data.metaKey === true ||
                        (data.domEvent.keyCode <= 46 /* control chars */ && data.domEvent.keyCode != 32 /* Space */) ||
                        (data.domEvent.keyCode >= 112 /* function keys (F1,...) */ && data.domEvent.keyCode < 186 /* control chars before semicolon */)

                    if (isAllowed === false) {
                        eventInfo.stop();
                        data.stopPropagation();
                        data.preventDefault();

                        return false;
                    }
                }
            }

            function checkLength(currentLength, maximumLength, addedCharCount) {
                counterField.innerText = `${currentLength}/${maximumLength}`;

                if (currentLength > 0 && (currentLength >= (maximumLength * maxLengthVisibleAt) || currentLength >= maximumLength)) {
                    // Show container with input limitations 
                    counterField.style.display = 'inline-block';
                    counterField.style.opacity = '1';
                }
                else {
                    // Hide container with input limitations 
                    counterField.style.display = null;
                    counterField.style.opacity = null;
                }

                return (currentLength + (addedCharCount ?? 1)) > maximumLength;
            }

            editor.on('ready', async () => {
                while (editor.ui.view.element.parentNode === null) {
                    await sleep(50);
                }

                editor.ui.view.element.insertAdjacentElement('afterend', counterField);

                wordCountPlugin.on('update', (evt, stats) => {
                    checkLength(stats.characters, maxLength, 0);
                });

                editor.editing.view.document.on('paste', function(eventInfo, data) {
                    let selectedTextLength = 0,
                        selectionItems = editor.model.document.selection.getFirstRange().getItems(),
                        selectedElement = null;

                    while ((selectedElement = selectionItems.next()).done === false) {
                        selectedTextLength += selectedElement.value.data?.length ?? 0;
                    }

                    if (checkLength(wordCountPlugin.characters, maxLength, wordCountPlugin._getCharacters(data.dataTransfer.getData('text/plain')) - selectedTextLength)) {
                        eventInfo.stop();
                        data.stopPropagation();
                        data.preventDefault();

                        editor.fire('pasteBlocked');

                        return false;
                    }
                }, { priority: 'highest' });

                editor.editing.view.document.on('keydown', function(eventInfo, data) {
                    return checkAbort(eventInfo, data);
                }, { priority: 'highest' });

                editor.on('destroy', () => {
                    counterField.remove();
                });

                checkLength(wordCountPlugin.characters, maxLength, 0);
            });
        }
    }
}